module.exports = new __parcel__URL__("nist-influx--dataset-cover.ecc6247d.png").toString();